module.exports = __webpack_public_path__ + "06f9b3aa498154e4b789f4856c11ad3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Giudice.jpg
// module id = LWmR
// module chunks = 0